import React, { useEffect, useState, useContext } from 'react'
import { KEYS, NUMBER_REGEX } from '../../utils/constant'
import { SessionStorage } from '../../utils/storage'
import { TranslatedPrefix, alphabeticName, replaceEmoji } from '../../utils/utils'
import Checkbox from '../common/Checkbox'
import Input from '../common/Input'
import PhoneInput from '../common/Input/phoneInput'
import Select from '../common/Select'
import GuestDetails from './guestDetails'
import AppContext from '../../utils/appContext'
import { useTranslation } from "react-i18next"
import { PREFIX } from '../../utils/utils'

const ContactDetails = ({
    activeTab,
    // activeTabGuest,
    handleTabClick,
    stopClose,
    // handleTabClickGuest,
    register,
    errors,
    setValue,
    getValues,
    control,
    watch,
    clearErrors,
    trigger,
    resetField,
    addonData,
    bookingData,
    checkoutData,
}) => {
	const { t } = useTranslation();
	const [checkboxIndex, setCheckBoxIndex] = useState();
	let context = useContext(AppContext);

	const updateData = () => {
		const roomData = SessionStorage.getJSON(KEYS.ROOM_DATA);
		if (bookingData?.guest_details?.[0]?.iamstay === 1) {
			setCheckBoxIndex(0);
		}
		const newData = roomData?.map((detail, index) => ({
			prefix:
				index === 0
					? bookingData?.guest_details?.[0]?.title
					: undefined,
			firstName:
				index === 0
					? bookingData?.guest_details?.[0]?.firstName
					: undefined,
			lastName:
				index === 0
					? bookingData?.guest_details?.[0]?.lastName
					: undefined,
			arrivalTime: undefined,
			stayInRoom:
				index === 0 && bookingData?.guest_details?.[0]?.iamstay === 1
					? true
					: false,
			additional: undefined,
			...detail,
			addonData: addonData?.map((add) => ({
				...add,
				count:
					detail.enhancement?.find((enh) => enh.id === add.id)
						?.count || 0,
			})),
		}));
		setValue("guest", newData);
	};

	useEffect(updateData, [addonData]);

	useEffect(() => {
		if (context.enhancementChange) {
			updateData();
			context.setEnhancementChange(false);
		}
	}, [context.enhancementChange]);

	const handleKeyPress = (event) => {
		if (event.key === "Enter") {
			handleTabClick(0);
		}
	};

	let language = localStorage.getItem("i18nextLng")
		? localStorage.getItem("i18nextLng")
		: "en";

	const TRANS_PREFIX = TranslatedPrefix(PREFIX, language);

	return (
		<div
			className={`checkoutTab ${
				activeTab === 0 ? "checkoutTabShow" : ""
			}`}
			tabIndex='0'
			onClick={(e) => handleTabClick(0)}
			onKeyPress={(e) => handleKeyPress(e)}
		>
				{getValues("guest")?.length ? (
					<GuestDetails
						control={control}
						setValue={setValue}
						errors={errors}
						// activeTabGuest={activeTabGuest}
						stopClose={stopClose}
						// handleTabClickGuest={handleTabClickGuest}
						register={register}
						getValues={getValues}
						watch={watch}
						checkboxIndex={checkboxIndex}
						setCheckBoxIndex={setCheckBoxIndex}
						clearErrors={clearErrors}
						checkoutData={checkoutData}
						trigger={trigger}
						bookingData={bookingData}
					/>
				) : (
					""
				)}
			</div>
	);
}

export default ContactDetails
